<div class="status-show-error" *transloco="let t">
	<op-masthead [title]="t('ESIGN.ERROR_PAGE.title')"></op-masthead>
	<op-content-container class="content">
		<div class="op-icon-align-body-1">
			<mat-icon svgIcon="op-alert"></mat-icon>
			<span [innerHTML]="t('ESIGN.ERROR_PAGE.message')"></span>
		</div>
	</op-content-container>
</div>
